import React from 'react';
import { useLocation } from 'react-router';
import { ErrorBoundary } from 'react-error-boundary';
import { AuthProvider } from './config/reducer/Auth';
import BrokenPage from './pages/errorPage/BrokenPage';
import Router from './config/routes/routes';
import { NotificationProvider } from './context/NotificationContext';
import './App.css';

function logRuntimeError(error, info) {
  // eslint-disable-next-line no-console
  console.error('Uncaught render error:', error, info?.componentStack);
}

function App() {
  // Reset the boundary whenever the route changes, so navigating away from the
  // fallback (e.g. BrokenPage's "Go back" / "take me home") re-mounts the router
  // instead of leaving the error state latched until a full page reload.
  const { pathname } = useLocation();
  return (
    <div className="App">
      <ErrorBoundary FallbackComponent={BrokenPage} onError={logRuntimeError} resetKeys={[pathname]}>
        <AuthProvider>
          <NotificationProvider>
            <Router />
          </NotificationProvider>
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
